<b> {{ 'admin.settings.subTitle' | translate }}</b>
<div class="d-flex justify-content-between mt-2">
  <p>
    {{ 'admin.settings.approvedSecurities' | translate }}
  </p>
  <ap-toggle
    (onChange)="changeConfiguration($event)"
    [large]="true"
    [ngModel]="toggleStatus()">
  </ap-toggle>
</div>
